declare var BuildDateTime: string;

interface ApplyLoginStyleInjectionOptions {
    basePath?: string;
    loginFrameId?: string;
}

interface Window {
    SPLUSDock2Layout?: {
        applyLoginStyleInjection?: (ApplyLoginStyleInjectionOptions) => void;
    };
}

if (window.SPLUSDock2Layout === undefined) window.SPLUSDock2Layout = {};

const animationSeconds: number = 0.5;

window.SPLUSDock2Layout.applyLoginStyleInjection = (options?: ApplyLoginStyleInjectionOptions): void => {
    if (options === undefined) options = {};

    let basePath: string = options.basePath;
    if (basePath === undefined) basePath = '/services/printing/dock2';

    let loginFrameId: string = options.loginFrameId;
    if (loginFrameId === undefined) loginFrameId = 'LoginFrame';

    const readyStates = ['complete', 'interactive'];
    function documentIsReady(readyState: string): boolean {
        return readyStates.indexOf(readyState) !== -1; // IE11 support, originally: readyStates.includes(readyState);
    }

    function startStyleInjection(): void {
        const loginFrameElement: HTMLElement = document.getElementById(loginFrameId);
        if (loginFrameElement === null) throw `There is no iframe element with 'id' attribute set to '${loginFrameId}'.`;
        if (loginFrameElement.nodeName !== 'IFRAME') throw `The element with id '${loginFrameId}' is a ${loginFrameElement.nodeName} element, not an IFRAME element.`;

        const loadingAnimation: HTMLElement = document.createElement('div');

        function setLoadingAnimationSize() {
            loadingAnimation.style.width = `${loginFrameElement.offsetWidth}px`;
            loadingAnimation.style.height = `${loginFrameElement.offsetHeight}px`;
            loadingAnimation.style.left = `${loginFrameElement.offsetLeft}px`;
            loadingAnimation.style.top = `${loginFrameElement.offsetTop}px`;
        }

        loadingAnimation.className = 'loginStyleInjectionLoadingContainer';
        loadingAnimation.style.transition = `opacity ${animationSeconds}s`;
        loadingAnimation.style.position = 'absolute';
        setLoadingAnimationSize();
        loadingAnimation.innerHTML = `
            <div class="showbox" style="background: white;">
                <div class="splus-loader no-smil" style="position: absolute;">
                    <div class="splus-legacy-loader" style="display: block !important;"></div>
                </div>
            </div>`;
        loginFrameElement.parentNode.insertBefore(loadingAnimation, loginFrameElement.nextSibling);

        loginFrameElement.style.opacity = '0';
        loginFrameElement.style.transition = `opacity ${animationSeconds}s`;

        new MutationObserver(setLoadingAnimationSize).observe(loginFrameElement, {
            attributes: true,
            attributeFilter: ['width', 'height', 'style']
        });

        const loginFrameWindow = (<HTMLIFrameElement>loginFrameElement).contentWindow;

        loginFrameElement.addEventListener('load', () => {
            window.postMessage(JSON.stringify({
                loginPage: loginFrameWindow.location.pathname === '/idm/com/login',
                registerPage: loginFrameWindow.location.pathname === '/idm/com/createaccount'
            }), window.origin || window.location.origin);
            loginFrameElement.style.opacity = '1';
            loadingAnimation.style.opacity = '0';
            setTimeout(() => { loadingAnimation.style.display = 'none'; }, animationSeconds*1000);
            loginFrameWindow.addEventListener('beforeunload', () => {
                loginFrameElement.style.opacity = '0';
                loadingAnimation.style.display = 'block';
                requestAnimationFrame(() => loadingAnimation.style.opacity = '1');
            });
        });
    }

    if (documentIsReady(document.readyState)) {
        startStyleInjection();
    } else {
        document.addEventListener('DOMContentLoaded', startStyleInjection);
    }
};
